// import { Suspense } from "react";
import React from "react";
import { openModal, Modal, closeModal, notifyLoading, notifyError } from "../modal.js";
// import LoadingSpinner from './loadingSpinner.mjs';
import OrderingGrid from './orderingGrid.js';
import { fetchJson } from "../fetch.js";
// const OrderingGrid = React.lazy(() => import('./orderingGrid.js'));
import BudgetModal from "./budgetConsequences.js";
import { PubSub } from '../weave/helpers.mjs';
import { saveOrderingGridConfig, deleteOrderingGridConfig, getAuthorityIdFromCookie } from "./orderingGridStorage.mjs";

class OrderingGridModal extends React.Component {
    /* constructor(props) {
        super(props);
        this.state = {
            data: null
        };
    } */

    /* componentDidMount() {
        PubSub.sub("orderingGridInit", this.init.bind(this));
    }

    init(data) {
        this.setState({
            data: data
        });
    } */

    onConfirm(next = false) {
        const qty = this.props.data.data.reduce((prev, cur) => prev + Number(cur.quantity), 0);
        const isWeave = this.props.activeBasket?.type == "Weave";

        // if the user sets the quantity to 0 the delete item flow is triggered instead
        if (qty == 0 && isWeave) {
            const text = "Remove this item, or remove the item and exclude it from future selections";
            openModal("confirmDeleteItem", <span>Remove <i>{`${this.props.data.title}`}</i></span>, text);
            return;
        }

        notifyLoading('Saving...');
        const form = document.getElementById("orderingGrid");
        const orderingGridFormData = new FormData(form);

        var url = "/basketBranch/add/" + this.props.data.basketId + "/" + this.props.data.prId;
        if (this.props.fromBookshelf) {
            url = "/basketBranch/fromBookshelf/" + this.props.fromBookshelf + "/" + this.props.data.basketId;
        }
        if (this.props.basketBuilderData && this.props.basketBuilderData.length > 0) {
            var bbData = this.props.basketBuilderData;
            url = "/search/fromBasketBuilder/" + bbData[0].basketValue;
            if (bbData[0].profileId) {
                url += "/" + bbData[0].profileId;
            } else {
                var defaultProfileId = 0; // NO PROFILE ID SELECTED
                url += "/" + defaultProfileId;
            }
            url += "/" + this.props.data.basketId;

            var basketBuilderClass = $("#basketBuilderModal").attr("class");
            // Basket builder via boolean search page
            if (basketBuilderClass == "booleanBasketBuilder") {
                orderingGridFormData.append("searchPageType", "boolean");
                updateFilterItemArray();
                orderingGridFormData.append("searchFilterItems", JSON.stringify(filterItems));
            }
            // Basket builder via advanced search page
            else if (basketBuilderClass == "advancedBasketBuilder") {
                orderingGridFormData.append("searchPageType", "advanced");
                const advancedSearchFormData = new FormData($('#searchForm')[0]);
                for (var pair of advancedSearchFormData.entries()) {
                    orderingGridFormData.append(pair[0], pair[1]);
                }
            }
        }

        const ediPropertyByEdiId = {};
        this.props.data.ediOptions.forEach(edi => {
            const match = this.props.data.basketOptions.find(opt => opt.edi == edi.aoEdiId);
            if (match) {
                ediPropertyByEdiId[edi.aoEdiId] = match.ediCode;
            }
        });

        fetchJson(url, orderingGridFormData).then(r => {
            if (r.error) {
                notifyError(r.error); // "No search filters" for example
            }
            PubSub.pub("saveOrderingGrid", this.props.data.prId, r.newTotalQuantity);
            PubSub.pub("addToBasketModal_close");
            if (r.unavailable) {
                notifyError("The following unavailable titles were not added", r.unavailable.join(", "));
            }
            if (next == true) {
                PubSub.pub("goToNextResult", this.props.data.prId, this.props.data.basketId);
            }

            let authorityId = getAuthorityIdFromCookie()
            if (orderingGridFormData.get('rememberChoices') === 'on') {
                const config = {
                    branches: this.props.data.data.map(branch => {
                        const options = {};
                        this.props.data.ediOptions.forEach(edi => {
                            const propertyName = ediPropertyByEdiId[edi.aoEdiId];
                            const selectedCode = propertyName ? branch[propertyName]: null;
                            if (selectedCode) {
                                const match = this.props.data.basketOptions.find(opt => opt.edi === edi.aoEdiId && opt.code === selectedCode);
                                if (match) {
                                    options[edi.aoEdiId] = {id:match.id, code:match.code};
                                }
                            }
                        })
                        return { 
                            branchId: branch.branchId, 
                            quantity: branch.quantity, 
                            options,
                            stockCategory: this.props.data.showStockCategories ? (branch.stockCategory || null) : null
                        };
                    })
                }
                saveOrderingGridConfig(authorityId, config);
            } else {
                deleteOrderingGridConfig(authorityId)
            }
        });
    }

    deleteItem(exclude = null) {
        const basketId = this.props.data.basketId;
        const selectedItemId = this.props.data.prId;

        closeModal("confirmDeleteItem");
        notifyLoading("Deleting...");

        const url = "/basket/remove/" + basketId + "/" + selectedItemId + (exclude ? ("/exclude") : "");

        if (selectedItemId && basketId) {
            fetchJson(url).then(r => {
                PubSub.pub("saveOrderingGrid", this.props.data.prId, 0);
                PubSub.pub("addToBasketModal_close");
            });
        } else {
            alert('Failed to remove item.');
        }
    }

    render() {
        if (!this.props.data) {
            return null;
            // return <Modal id="addToBasketModal" body={<LoadingSpinner />} buttons={[]} />
        }

        var buttons = [
            {
                id: "1",
                text: "Confirm",
                classes: "btn-primary",
                onClick: () => this.onConfirm(false)
            },
            {
                id: "2",
                text: "Cancel",
                classes: "btn-light",
                onClick: () => {
                    PubSub.pub("libsCheckoutCancelGrid", this.props.data.prId);
                    PubSub.pub("forSchoolCheckoutCancelGrid", this.props.data.prId);
                    PubSub.pub("addToBasketModal_close");
                }
            }
        ];

        if (this.props.data && this.props.data.showStockCategories && this.props.data.internal == 1) {
            buttons.push({
                id: "3",
                text: "Budget outcome",
                classes: "btn-primary",
                onClick: () => {
                    PubSub.pub("budgetModal", this.props.data.basketId, this.props.data.data.map(basketBranch => ({
                        ...basketBranch,
                        items: basketBranch.quantity,
                        total: (Number(basketBranch.price) + Number(basketBranch.servicing)) * Number(basketBranch.quantity),
                        stockCategoryId: basketBranch.stockCategory
                    })), this.props.data.prId)
                }
            });
        }

        const navnext = document.querySelector(".productNav.navNext");
        // opened from a result on a search results list (not from a bookshelf or the basket builder)
        const fromSearchList = !this.props.fromBookshelf && !(this.props.basketBuilderData && this.props.basketBuilderData.length > 0)
            && document.querySelector(`.productContainer.searchBox[data-prid="${this.props.data.prId}"]`);
        if (navnext || fromSearchList || (document.querySelector("#checkoutSections") && this.props.data.availability)) {
            buttons.push({
                id: "4",
                text: "Save and go to next",
                classes: "btn-primary",
                onClick: () => {
                    this.onConfirm(true);
                }
            });
        }

        const deleteButtons = [
            {
                id: "1",
                text: "Remove",
                classes: "btn-primary",
                onClick: () => this.deleteItem(),
            },
            {
                id: "2",
                text: "Remove and exclude",
                classes: "btn-primary",
                onClick: () => this.deleteItem(true),
            },
            {
                id: "3",
                text: "Cancel",
                close: true,
                classes: "btn-light"
            }
        ];

        /* const body = <React.Suspense fallback={<LoadingSpinner />}>
            <OrderingGrid fromBookshelf={this.props.fromBookshelf} data={this.props.data} getItemServicingTotal={this.props.getItemServicingTotal} />
        </React.Suspense> */

        const body = <OrderingGrid fromBookshelf={this.props.fromBookshelf} basketBuilderData={this.props.basketBuilderData} data={this.props.data} getItemServicingTotal={this.props.getItemServicingTotal} orderingGridMemoryEnabled={this.props.orderingGridMemoryEnabled}/>;

        return (<>
            <Modal id="addToBasketModal" body={body} heading={this.props.data.basketName} buttons={buttons} onCancelCallback={() => {
                PubSub.pub("libsCheckoutCancelGrid", this.props.data.prId);
                PubSub.pub("forSchoolCheckoutCancelGrid", this.props.data.prId);
            }} />
            {this.props.data.showStockCategories && this.props.data.internal == 1 && <BudgetModal />}
            {this.props.activeBasket && this.props.activeBasket.type == "Weave" && <Modal id="confirmDeleteItem" buttons={deleteButtons} />}
        </>);
    }
}

export default OrderingGridModal;
